// Basket keys stay `{ key: quantity }` end-to-end. A key is either a bare
// menu-item id (no add-ons) or a composite `"<itemId>:<addOnId>+<addOnId>"`
// with add-on ids sorted. UUIDs contain `-` but never `:` or `+`, so those
// separators are unambiguous.
// Mirrors app/controllers/concerns/basket_key.rb — keep in sync.

export function buildKey(itemId, addOnIds = []) {
  const ids = (addOnIds || []).map(String).filter(Boolean)
  if (ids.length === 0) return String(itemId)
  return `${itemId}:${[...ids].sort().join('+')}`
}

export function parseKey(key) {
  const str = String(key)
  const idx = str.indexOf(':')
  if (idx === -1) return { menuItemId: str, addOnIds: [] }
  const menuItemId = str.slice(0, idx)
  const addOnIds = str.slice(idx + 1).split('+').filter(Boolean)
  return { menuItemId, addOnIds }
}
